import LinearProgress from "@mui/material/LinearProgress";
import { lazy, Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import CompleteSignupGuard from "../../../../../Guards/CompleteSignupGuard/CompleteSignupGuard";
import ScrollToTop from "../ScrollToTop/ScrollToTop";
import ROUTES, { ROUTE_PARAM_KEYS } from "./routes";
import styles from "./styles.module.css";
import { Albums } from "../../../../../../../pages/Albums/Albums";

const Home = lazy(() => import("../../../../../../../pages/Home/Home"));

const ActivatePushNotifications = lazy(
  () =>
    import("../../../../../../../pages/ActivatePushNotifications/ActivatePushNotifications"),
);

const CloseAccount = lazy(
  () => import("../../../../../../../pages/CloseAccount/CloseAccount"),
);

const CloseAccountConfirmation = lazy(
  () =>
    import("../../../../../../../pages/CloseAccountConfirmation/CloseAccountConfirmation"),
);

const Notifications = lazy(
  () => import("../../../../../../../pages/Notifications/Notifications"),
);

const NotificationSent = lazy(
  () => import("../../../../../../../pages/NotificationSent/NotificationSent"),
);

const PrivacyPolicy = lazy(
  () => import("../../../../../../../pages/PrivacyPolicy/PrivacyPolicy"),
);

const StickerManager = lazy(
  () => import("../../../../../../../pages/StickerManager/StickerManager"),
);

const SignIn = lazy(() => import("../../../../../../../pages/SignIn/SignIn"));

const StickerComparison = lazy(
  () =>
    import("../../../../../../../pages/StickerComparison/StickerComparison"),
);

const StickerSearch = lazy(
  () => import("../../../../../../../pages/StickerSearch/StickerSearch"),
);

const StickerSearchResults = lazy(
  () =>
    import("../../../../../../../pages/StickerSearchResults/StickerSearchResults"),
);

const TermsOfService = lazy(
  () => import("../../../../../../../pages/TermsOfService/TermsOfService"),
);

const UpdateProfile = lazy(
  () => import("../../../../../../../pages/UpdateProfile/UpdateProfile"),
);

export default function AppRouter() {
  return (
    <div className={styles.container}>
      <Router>
        <ScrollToTop />
        <Suspense fallback={<LinearProgress />}>
          <Routes>
            <Route index element={<Home />} />

            <Route element={<CompleteSignupGuard />}>
              <Route
                path={ROUTES.ACTIVATE_PUSH_NOTIFICATIONS}
                element={<ActivatePushNotifications />}
              />
              <Route path={ROUTES.ALBUMS} element={<Albums />} />
              <Route path={ROUTES.CLOSE_ACCOUNT} element={<CloseAccount />} />
              <Route
                path={ROUTES.CLOSE_ACCOUNT_CONFIRMATION}
                element={<CloseAccountConfirmation />}
              />
              <Route path={ROUTES.NOTIFICATIONS} element={<Notifications />} />
              <Route
                path={ROUTES.NOTIFICATION_SENT}
                element={<NotificationSent />}
              />
              <Route
                path={`${ROUTES.STICKERS}/:${ROUTE_PARAM_KEYS.ALBUM_ID}`}
                element={<StickerManager />}
              />
              <Route path={ROUTES.SIGN_IN} element={<SignIn />} />
              <Route path={ROUTES.STICKER_SEARCH} element={<StickerSearch />} />
              <Route
                path={ROUTES.STICKER_SEARCH_RESULTS}
                element={<StickerSearchResults />}
              />
              <Route
                path={ROUTES.STICKER_COMPARISON}
                element={<StickerComparison />}
              />
            </Route>

            <Route path={ROUTES.PRIVACY_POLICY} element={<PrivacyPolicy />} />

            <Route
              path={ROUTES.TERMS_OF_SERVICE}
              element={<TermsOfService />}
            />

            <Route path={ROUTES.UPDATE_PROFILE} element={<UpdateProfile />} />
          </Routes>
        </Suspense>
      </Router>
    </div>
  );
}
